module.exports = __webpack_public_path__ + "img/player-play-icon.70ce5b83.svg";